import React, { useState, useEffect } from "react";
import {
    Paper,
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    Button,
    Typography,
    TextField,
    MenuItem,
    Select,
    FormControl,
    InputLabel,
    Avatar,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Chip,
    FormLabel,
    Checkbox,
    ListItemText,
} from "@mui/material";
import configData from "../config.json";
import { useNavigate } from "react-router-dom";
import { getToken } from "../utils/auth";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// Mock async service for branches

export default function UserManagement() {
    const navigate = useNavigate();
    const fetchFieldUsersData = async () => {
        try {
            const token = getToken();
            const res = await fetch(`${configData.SERVER_URL}/Users_data`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "x-access-token": token,
                },
            });

            if (!res.ok) navigate("/");

            const data = await res.json();
            return data
        } catch (error) {
            navigate("/"); // redirect on error
        }
    };

    const [users, setUsers] = useState([]);
    const [roles, setRoles] = useState([]);
    const [branches, setBranches] = useState([]);
    const [filters, setFilters] = useState({ search: "", branchId: "" });

    const [addingUser, setAddingUser] = useState(null);
    const [editingUser, setEditingUser] = useState(null);
    const [userToDelete, setUserToDelete] = useState(null);

    const [CurrentEmail, setEditCurrentEmail] = useState(null);
    const [refreshData, setrefreshData] = useState(false);

    const [editUserDialog, setEditUserDialog] = useState(false);
    const [addUserDialog, setAddUserDialog] = useState(false);
    const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);


    const transformUserData = (tupleData) => {
        if (!Array.isArray(tupleData)) {
            return [];
        }

        return tupleData.map(([id, email, role, branches]) => ({
            id,
            email,
            userName: email.split("@")[0],
            role,
            branchIds: branches || [],
        }));
    };

    useEffect(() => {
        const fetchData = async () => {
            const fieldData = await fetchFieldUsersData();
            const { fieldUsersData = [], roles = [], branch_ids = [] } = fieldData || {};
            const transformedData = transformUserData(fieldUsersData);
            setRoles(Array.isArray(roles) ? roles : []);
            setBranches(Array.isArray(branch_ids) ? branch_ids : []);
            setUsers(transformedData);
        };

        fetchData();
    }, [refreshData]);

    const filteredUsers = users.filter((u) => {
        const matchesSearch =
            u.userName.toLowerCase().includes(filters.search.toLowerCase()) ||
            u.email.toLowerCase().includes(filters.search.toLowerCase());
        const matchesBranch =
            !filters.branchId || u.branchIds.includes(Number(filters.branchId));
        return matchesSearch && matchesBranch;
    });
    const handleDelete = (user) =>
        setUsers(users.filter((u) => u.id !== user.id));

    const handleEdit = (user) => {
        setEditingUser({ ...user, password: "" });
        setEditCurrentEmail(user.email)
        setEditUserDialog(true);
    };

    const addFieldUsersData = async () => {
        const userEmail = addingUser.email
        const userBranches = addingUser.branchIds
        const userRole = addingUser.role
        const userPassword = addingUser.password?.trim() ?? ""
        try {
            const token = getToken();
            const res = await fetch(`${configData.SERVER_URL}/Users_data`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "x-access-token": token,
                },
                body: JSON.stringify({   // <-- stringify the object
                    userBranches: userBranches,
                    userEmail: userEmail,
                    userRole: userRole,
                    userPassword: userPassword,
                })
            });

            if (!res.ok) {
                const err = await res.json();
                toast.error(`Failed to add user: ${err.message || res.status}`);
                return;
            }
            toast.success(`${userEmail} Added successfully`);
            setrefreshData(!refreshData);
            return
        } catch (error) {
            toast.error("Failed to update user");
            return
        }
    }
    const addUserhandleSave = () => {
        const addUser = async () => {
            await addFieldUsersData();
            return
        }
        addUser()
        setAddUserDialog(false);
        setAddingUser(null);
    };

    const editFieldUsersData = async () => {
        const userEmail = editingUser.email
        const userBranches = editingUser.branchIds
        const userRole = editingUser.role
        const userPassword = editingUser.password?.trim() ?? ""
        try {
            const token = getToken();
            const res = await fetch(`${configData.SERVER_URL}/Users_data`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    "x-access-token": token,
                },
                body: JSON.stringify({
                    editUserBranches: userBranches,
                    editUserEmail: userEmail,
                    editUserRole: userRole,
                    userEmail: CurrentEmail,
                    editUserPassword: userPassword,
                })
            });

            if (!res.ok) {
                const err = await res.json();
                console.log(err);
                toast.error(`Failed to update user: ${err.message}`);
                return;
            }
            toast.success("User updated successfully");
            setrefreshData(!refreshData);
            return
        } catch (error) {
            toast.error("Failed to update user");
            return
        }
    };

    const editUserhandleSave = () => {
        const editUser = async () => {
            await editFieldUsersData();
            return
        }
        editUser()
        setEditUserDialog(false);
        setEditingUser(null);
        setEditCurrentEmail(null)
    };

    const deleteFieldUsersData = async (user) => {
        try {
            const token = getToken();
            const res = await fetch(`${configData.SERVER_URL}/Users_data`, {
                method: "DELETE",
                headers: {
                    "Content-Type": "application/json",
                    "x-access-token": token,
                },
                body: JSON.stringify({ userEmail: user.email })
            });
            const data = await res.json();
            console.log(data);
            if (res.ok) {
                toast.success(`${user.email} deleted successfully`);
                handleDelete(user);
            } else {
                toast.error(`Failed to delete user: ${data.message || res.status}`);
            }
        }
        catch (error) {
            toast.error(`Failed to delete user: ${error.message}`);
            return
        }
        finally {
            setDeleteDialogOpen(false);
            setUserToDelete(null);
        }
    };



    return (
        <Paper className="p-6" style={{ height: "80vh", display: "flex", flexDirection: "column" }}>
            <ToastContainer position="top-right" autoClose={3000} />
            <Typography variant="h5" gutterBottom>
                User Management
            </Typography>

            {/* Filters */}
            <div style={{ display: "flex", gap: 16, marginBottom: 16, alignItems: "center" }}>
                <TextField
                    label="Search"
                    value={filters.search}
                    onChange={(e) => setFilters({ ...filters, search: e.target.value })}
                    size="small"
                />

                <Button
                    variant="contained"
                    color="primary"
                    size="small"
                    onClick={() => {
                        setAddingUser({ email: "", role: "", branchIds: [], password: "" });
                        setAddUserDialog(true);
                    }}
                >
                    Add User
                </Button>
            </div>

            {/* Add User Dialog */}
            <Dialog
                open={addUserDialog}
                onClose={() => {
                    setAddUserDialog(false);
                    setAddingUser(null);
                }}
            >
                <DialogContent
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 24,
                        marginTop: 16,
                        minWidth: 400,
                    }}
                >
                    <FormControl fullWidth margin="normal">
                        <FormLabel style={{ marginBottom: 8, fontWeight: 500 }}>Email</FormLabel>
                        <TextField
                            value={addingUser?.email || ""}
                            onChange={(e) =>
                                setAddingUser({ ...addingUser, email: e.target.value })
                            }
                        />
                    </FormControl>

                    <FormControl fullWidth margin="normal">
                        <FormLabel style={{ marginBottom: 8, fontWeight: 500 }}>Role</FormLabel>
                        <Select
                            value={addingUser?.role || ""}
                            onChange={(e) =>
                                setAddingUser({ ...addingUser, role: e.target.value })
                            }
                        >
                            {roles.map((role) => (
                                <MenuItem key={role} value={role}>
                                    {role}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>

                    <FormControl fullWidth margin="normal">
                        <FormLabel style={{ marginBottom: 8, fontWeight: 500 }}>Password</FormLabel>
                        <TextField
                            type="password"
                            value={addingUser?.password ?? ""}
                            onChange={(e) =>
                                setAddingUser({ ...addingUser, password: e.target.value })
                            }
                            autoComplete="new-password"
                        />
                    </FormControl>

                    <FormControl fullWidth margin="normal">
                        <FormLabel style={{ marginBottom: 8, fontWeight: 500 }}>Branches</FormLabel>
                        <Select
                            multiple
                            value={addingUser?.branchIds || []}
                            onChange={(e) =>
                                setAddingUser({
                                    ...addingUser,
                                    branchIds: e.target.value,
                                })
                            }
                            renderValue={(selected) => (
                                <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
                                    {selected.map((id) => (
                                        <Chip key={id} label={id} size="small" />
                                    ))}
                                </div>
                            )}
                        >
                            {branches.map((branch) => (
                                <MenuItem key={branch} value={branch}>
                                    <Checkbox checked={addingUser?.branchIds?.indexOf(branch) > -1} />
                                    <ListItemText primary={branch} />
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </DialogContent>

                <DialogActions>
                    <Button
                        onClick={() => {
                            setAddUserDialog(false);
                            setAddingUser(null);
                        }}
                    >
                        Cancel
                    </Button>
                    <Button onClick={addUserhandleSave} variant="contained" color="primary">
                        Save
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Scrollable Table Container */}
            <div
                style={{
                    flex: 1,
                    overflowY: "auto",
                    borderRadius: 8,
                    border: "1px solid #ddd",
                }}
            >
                <Table stickyHeader>
                    <TableHead>
                        <TableRow>
                            <TableCell>Username</TableCell>
                            <TableCell>Email</TableCell>
                            <TableCell>Role</TableCell>
                            <TableCell>Branches</TableCell>
                            <TableCell>Actions</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {filteredUsers.map((user) => (
                            <TableRow key={user.id}>
                                <TableCell>{user.userName}</TableCell>
                                <TableCell>{user.email}</TableCell>
                                <TableCell>{user.role}</TableCell>
                                <TableCell>{user.branchIds.join(", ")}</TableCell>
                                <TableCell>
                                    <Button
                                        variant="outlined"
                                        size="small"
                                        onClick={() => handleEdit(user)}
                                        style={{ marginRight: 4 }}
                                    >
                                        Edit User
                                    </Button>
                                    <Button
                                        variant="outlined"
                                        size="small"
                                        color="error"
                                        onClick={() => {
                                            setUserToDelete(user);
                                            setDeleteDialogOpen(true);
                                        }}
                                    >
                                        Delete
                                    </Button>

                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </div>

            {/* Delete Confirmation Dialog */}
            <Dialog
                open={deleteDialogOpen}
                onClose={() => setDeleteDialogOpen(false)}
            >
                <DialogTitle>Confirm Deletion</DialogTitle>
                <DialogContent>
                    Are you sure you want to delete user <strong>{userToDelete?.email}</strong>?
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setDeleteDialogOpen(false)}>Cancel</Button>
                    <Button
                        variant="contained"
                        color="error"
                        onClick={() => deleteFieldUsersData(userToDelete)}
                    >
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Edit User Dialog */}
            <Dialog
                open={editUserDialog}
                onClose={() => {
                    setEditUserDialog(false);
                    setEditingUser(null);
                    setEditCurrentEmail(null);
                }}
            >
                <DialogContent
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 24,
                        marginTop: 16,
                        minWidth: 400,
                    }}
                >
                    <FormControl fullWidth margin="normal">
                        <FormLabel style={{ marginBottom: 8, fontWeight: 500 }}>Email</FormLabel>
                        <TextField
                            value={editingUser?.email || ""}
                            onChange={(e) =>
                                setEditingUser({ ...editingUser, email: e.target.value })
                            }
                        />
                    </FormControl>

                    <FormControl fullWidth margin="normal">
                        <FormLabel style={{ marginBottom: 8, fontWeight: 500 }}>Role</FormLabel>
                        <Select
                            value={editingUser?.role || ""}
                            onChange={(e) =>
                                setEditingUser({ ...editingUser, role: e.target.value })
                            }
                        >
                            {roles.map((role) => (
                                <MenuItem key={role} value={role}>
                                    {role}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>

                    <FormControl fullWidth margin="normal">
                        <FormLabel style={{ marginBottom: 8, fontWeight: 500 }}>Password</FormLabel>
                        <TextField
                            type="password"
                            value={editingUser?.password ?? ""}
                            onChange={(e) =>
                                setEditingUser({ ...editingUser, password: e.target.value })
                            }
                            autoComplete="new-password"
                        />
                    </FormControl>

                    <FormControl fullWidth margin="normal">
                        <FormLabel style={{ marginBottom: 8, fontWeight: 500 }}>Branches</FormLabel>
                        <Select
                            multiple
                            value={editingUser?.branchIds || []}
                            onChange={(e) =>
                                setEditingUser({
                                    ...editingUser,
                                    branchIds: e.target.value,
                                })
                            }
                            renderValue={(selected) => (
                                <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
                                    {selected.map((id) => (
                                        <Chip key={id} label={id} size="small" />
                                    ))}
                                </div>
                            )}
                        >
                            {branches.map((branch) => (
                                <MenuItem key={branch} value={branch}>
                                    <Checkbox
                                        checked={editingUser?.branchIds?.includes(branch) || false}
                                        size="small"
                                    />
                                    <ListItemText primary={branch} />
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>

                </DialogContent>

                <DialogActions>
                    <Button
                        onClick={() => {
                            setEditUserDialog(false);
                            setEditingUser(null);
                            setEditCurrentEmail(null);
                        }}
                    >
                        Cancel
                    </Button>
                    <Button onClick={editUserhandleSave} variant="contained" color="primary">
                        Save
                    </Button>
                </DialogActions>
            </Dialog>
        </Paper>
    );

}
